// Great-circle distance between two { lat, lng } points, in meters.
// Returns null for invalid coordinates; this is straight-line distance, not road distance.
export function distanceBetweenMarkers(markers) {
  if (markers.length !== 2) return null
  const coordinates = markers.flatMap(({ lat, lng }) => [Number(lat), Number(lng)])
  if (!coordinates.every(Number.isFinite)) return null
  const [lat1, lng1, lat2, lng2] = coordinates
  if (Math.abs(lat1) > 90 || Math.abs(lat2) > 90 || Math.abs(lng1) > 180 || Math.abs(lng2) > 180)
    return null
  const radians = (degrees) => (degrees * Math.PI) / 180
  const a =
    Math.sin(radians(lat2 - lat1) / 2) ** 2 +
    Math.cos(radians(lat1)) * Math.cos(radians(lat2)) * Math.sin(radians(lng2 - lng1) / 2) ** 2
  return 6378137 * 2 * Math.atan2(Math.sqrt(Math.min(1, a)), Math.sqrt(Math.max(0, 1 - a)))
}

// Initial compass direction from one { lat, lng } point to another, in degrees.
// 0 is north, 90 is east; negative angles turn west. Missing points return 0.
export function bearing(from, to) {
  if (!from || !to) return 0
  const radians = Math.PI / 180
  const delta = (to.lng - from.lng) * radians
  const a = from.lat * radians,
    b = to.lat * radians
  return (
    Math.atan2(
      Math.sin(delta) * Math.cos(b),
      Math.cos(a) * Math.sin(b) - Math.sin(a) * Math.cos(b) * Math.cos(delta)
    ) / radians
  )
}
